import React from 'react';

const InputDelegacao = ({
  className,
  name,
  label,
  inputRef,
  errors,
  control,
  watch,
  ...rest
}) => {
  const handleKeyDown = (e) => {
    let invalidChars = ['/', ';', '?', '\\'];
    const key = e.key;

    if (invalidChars.includes(key)) {
      e.preventDefault();
    }
  };

  const msgErro = errors && errors[name]?.message;
  return (
    <input
      type={rest.type || 'text'}
      name={name}
      ref={inputRef}
      className={className}
      onKeyDown={(e) => handleKeyDown(e)}
      {...rest}
    />
  );
};

export default InputDelegacao;
